import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/icon/drag.svg'


const _hoisted_1 = { class: "grid lg:grid-cols-3 md:grid-cols-1 gap-4" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "label-text required" }, "Kode Rute", -1)
const _hoisted_4 = { class: "invalid-feedback" }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "label-text required" }, "Nama Rute", -1)
const _hoisted_7 = { class: "invalid-feedback" }
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "label-text" }, "Keterangan", -1)
const _hoisted_10 = { class: "mb-4" }
const _hoisted_11 = { class: "flex align-items-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: "IsAirport",
  class: "ml-2"
}, " Rute Khusus Bandara ", -1)
const _hoisted_13 = { class: "mb-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm mb-1" }, "Aktif", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h4", null, "Pilih Terminal Rute", -1)
const _hoisted_16 = {
  class: "flex flex-col",
  style: {"min-height":"65vh"}
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex rounded-lg gap-2 items-center py-2 px-2 mb-2",
  style: {"background-color":"#EFF5FF"}
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle color-blue-1 text-xs font-bold" }),
  /*#__PURE__*/_createElementVNode("p", { class: "color-blue-1 text-xs font-bold" }, "Urutan dalam rute sangat berpengaruh, jadi pastikan urutan rute sudah benar!")
], -1)
const _hoisted_18 = { class: "mb-4" }
const _hoisted_19 = { class: "flex items-center container-select-drag" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "flex mr-3 cursor-move" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_21 = { class: "font-bold mr-3" }
const _hoisted_22 = { class: "w-full py-1 routeForm" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "flex justify-center" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-plus mr-2",
  style: {"font-size":"16px"}
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Tambah Terminal")
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = { class: "flex items-center mt-auto" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_31 = {
  key: 1,
  class: "text-red text-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Card = _resolveComponent("Card")!
  const _component_SelectFetch = _resolveComponent("SelectFetch")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_FieldArray = _resolveComponent("FieldArray")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Form = _resolveComponent("Form", true)!
  const _component_HjpConfirmationModal = _resolveComponent("HjpConfirmationModal")!

  return (_openBlock(), _createElementBlock("section", null, [
    (!_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_Form, {
          key: 0,
          onSubmit: _ctx.onSubmit,
          "validation-schema": _ctx.schema,
          "initial-values": _ctx.initialValues,
          ref: "refForm"
        }, {
          default: _withCtx(({ errors, values, setFieldValue }) => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_Card, { class: "card-no-shadow" }, {
                title: _withCtx(() => [
                  _createElementVNode("h4", null, _toDisplayString(_ctx.title), 1)
                ]),
                content: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_2, [
                      _hoisted_3,
                      _createVNode(_component_Field, { name: "Code" }, {
                        default: _withCtx(({ field, handleChange, handleBlur }) => [
                          _createVNode(_component_InputText, _mergeProps(field, {
                            onChange: handleChange,
                            onBlur: handleBlur,
                            class: `input-primary ${errors.Code ? 'input-invalid' : ''}`,
                            placeholder: "Tulis kode rute",
                            maxlength: 30
                          }), null, 16, ["onChange", "onBlur", "class"])
                        ]),
                        _: 2
                      }, 1024),
                      _createElementVNode("div", _hoisted_4, _toDisplayString(errors.Code), 1)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _hoisted_6,
                      _createVNode(_component_Field, { name: "Name" }, {
                        default: _withCtx(({ field, handleChange, handleBlur }) => [
                          _createVNode(_component_InputText, _mergeProps(field, {
                            onChange: handleChange,
                            onBlur: handleBlur,
                            class: `input-primary ${errors.Name ? 'input-invalid' : ''}`,
                            placeholder: "Tulis nama rute",
                            maxlength: 50
                          }), null, 16, ["onChange", "onBlur", "class"])
                        ]),
                        _: 2
                      }, 1024),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(errors.Name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _createVNode(_component_Field, {
                        name: "Description",
                        as: "textarea",
                        class: "input-primary",
                        placeholder: "Tulis keterangan"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_Field, { name: "IsAirport" }, {
                        default: _withCtx(({ field }) => [
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_Checkbox, _mergeProps(field, {
                              modelValue: field.value,
                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                              binary: true,
                              inputId: "IsAirport",
                              name: "IsAirport"
                            }), null, 16, ["modelValue", "onUpdate:modelValue"]),
                            _hoisted_12
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createVNode(_component_Field, { name: "IsActive" }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_InputSwitch, _mergeProps({ class: "input-success" }, field, {
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                            inputId: "isactive",
                            onChange: ($event: any) => (setFieldValue('IsActive', field.value))
                          }), null, 16, ["modelValue", "onUpdate:modelValue", "onChange"])
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_Card, { class: "card-no-shadow lg:col-span-2" }, {
                title: _withCtx(() => [
                  _hoisted_15
                ]),
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createVNode(_component_FieldArray, { name: "Routes" }, {
                      default: _withCtx(({ fields, push, remove, swap }) => [
                        _createVNode(_component_draggable, {
                          modelValue: values.Routes,
                          "onUpdate:modelValue": ($event: any) => ((values.Routes) = $event),
                          "item-key": "key",
                          onChange: (e) => _ctx.checkMove(e, swap)
                        }, {
                          item: _withCtx(({ element, index }) => [
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("div", _hoisted_19, [
                                _hoisted_20,
                                _createElementVNode("p", _hoisted_21, _toDisplayString(index + 1) + ".", 1),
                                _createElementVNode("div", _hoisted_22, [
                                  _createVNode(_component_Field, {
                                    id: `Routes[${index}]`,
                                    name: `Routes[${index}]`
                                  }, {
                                    default: _withCtx(({ field }) => [
                                      _createVNode(_component_SelectFetch, _mergeProps(field, {
                                        placeholder: 'Pilih Kota',
                                        modelValue: field.value,
                                        id: `routes-${index}`,
                                        inputId: `routesId-${index}`,
                                        endpoint: "/management/v1/MsStation",
                                        searchCustom: [['activeOnly', '=', true]],
                                        fieldLabel: (v) => `${v.CityName} - ${v.Name}`,
                                        clearable: false,
                                        searchFields: ['name']
                                      }), null, 16, ["modelValue", "id", "inputId", "fieldLabel"])
                                    ]),
                                    _: 2
                                  }, 1032, ["id", "name"]),
                                  _createVNode(_component_ErrorMessage, {
                                    class: "invalid-feedback absolute",
                                    name: `Routes[${index}].value`
                                  }, null, 8, ["name"])
                                ]),
                                _createElementVNode("i", {
                                  class: "pi pi-times absolute mr-3 text-sm cursor-pointer",
                                  onClick: ($event: any) => (remove(index)),
                                  style: {"right":"0"}
                                }, null, 8, _hoisted_23)
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"]),
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_ErrorMessage, {
                            class: "invalid-feedback mt-4",
                            name: "Routes"
                          })
                        ]),
                        _createElementVNode("div", {
                          class: "color-blue-1 text-center font-extrabold cursor-pointer mt-4",
                          onClick: ($event: any) => (push({ label: '', value: '' }))
                        }, _hoisted_28, 8, _hoisted_25)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]),
                footer: _withCtx(() => [
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_Button, {
                      class: "btn-back mr-2",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onBack()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_30
                      ]),
                      _: 1
                    }),
                    (!_ctx.isHasPrice)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          type: "submit",
                          class: "btn-primary mr-1",
                          disabled: _ctx.isHasPrice
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.modalConfirmation.btnSubmitTitle), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"]))
                      : _createCommentVNode("", true),
                    (_ctx.isHasPrice)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, "*Rute yang telah terpasang di harga tidak bisa diubah"))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema", "initial-values"]))
      : _createCommentVNode("", true),
    _createVNode(_component_HjpConfirmationModal, {
      show: _ctx.modalConfirmation.show,
      imgContent: _ctx.modalConfirmation.imgContent,
      title: _ctx.modalConfirmation.title,
      subTitle: _ctx.modalConfirmation.subTitle,
      btnSubmitTitle: _ctx.modalConfirmation.btnSubmitTitle,
      onHideDialog: _ctx.hideModalConfirmation,
      onOnSubmit: _ctx.doSubmitConfirm
    }, null, 8, ["show", "imgContent", "title", "subTitle", "btnSubmitTitle", "onHideDialog", "onOnSubmit"])
  ]))
}